import { cn } from '@/lib/shadcn/utils';
import { type Client, findClientBrand } from '@/modules/mcp/clientBrands';

const tileSizes = {
  /** The consent page header, beside Finlay's tile. */
  lg: {
    tile: 'size-14 rounded-2xl shadow-[0_6px_16px_rgba(24,24,28,0.07)] md:size-16 md:rounded-[18px]',
    mark: 'size-7 md:size-[30px]',
    initial: 'text-2xl',
  },
  /** A row in a list of connections. */
  sm: {
    tile: 'size-8 rounded-[9px]',
    mark: 'size-4',
    initial: 'text-[13px]',
  },
};

const tileClassName = (size: keyof typeof tileSizes) =>
  cn('flex shrink-0 items-center justify-center border', tileSizes[size].tile);

interface ClientTileProps {
  client: Client;
  size?: keyof typeof tileSizes;
}

/** The connecting app's logo, or its first letter when we don't know it. */
export const ClientTile = ({ client, size = 'lg' }: ClientTileProps) => {
  const brand = findClientBrand(client);

  if (!brand) {
    return (
      <div
        aria-hidden="true"
        className={cn(
          tileClassName(size),
          tileSizes[size].initial,
          'text-primary bg-[#f1eeff] font-semibold',
        )}
      >
        {client.clientName.trim().charAt(0).toUpperCase()}
      </div>
    );
  }

  return (
    <div className={cn(tileClassName(size), brand.tileClassName)}>
      <img
        src={brand.logo}
        alt={`${brand.name} logo`}
        className={tileSizes[size].mark}
      />
    </div>
  );
};

/** Finlay's tile, for the other end of the connection. */
export const FinlayTile = () => (
  <div className={cn(tileClassName('lg'), 'bg-background')}>
    <img src="/logo.png" alt="" className="h-[18px] w-auto" />
  </div>
);
